import React from 'react';
// Remove the Helmet import
// import { Helmet } from 'react-helmet';

import Section from './components/Section';

import Hero from './components/sections/Hero';
import Features from './components/sections/Features';
import SetupProcess from './components/sections/SetupProcess';
import Testimonials from './components/sections/Testimonials';
import FAQ from './components/sections/FAQ';
import Pricing from './components/sections/Pricing';
import Download from './components/sections/Download';
import CompaniesList from './components/sections/CompaniesList';
import ResponsiveHeader from './components/ResponsiveHeader';
import SocialMedia from './components/sections/SocialMedia';
import Footer from './components/sections/Footer';
import { TimerProvider } from './contexts/SubscriptionTimerContext';
import HowItWorks from './components/sections/HowItWorks';
import OurStory from './components/sections/OurStory';
import CityIntro from './components/sections/CityIntro';
import { CITY_PAGES } from './data/cities';

const Home = ({ channel }) => {
  return (
    <>
      <ResponsiveHeader title="LOWKEY" />
      <TimerProvider>
        <div>
          <main className="pt-16">
            <section id={'hero'}>
              <Hero channel={channel} />
            </section>
            <CompaniesList channel={channel} />
            {CITY_PAGES[channel] && (
              <Section id={'city'} topPadding="pt-16">
                <CityIntro channel={channel} />
              </Section>
            )}
            <Section id={'features'} topPadding="pt-16">
              <Features channel={channel} />
            </Section>
            <Section id={'howItWorks'}>
              <HowItWorks channel={channel} />
            </Section>
            <Section id={'setupProcess'}>
              <SetupProcess channel={channel} />
            </Section>
            <Section id={'testimonials'}>
              <Testimonials />
            </Section>
            <Section id={'story'}>
              <OurStory />
            </Section>
            <Section id={'faq'}>
              <FAQ channel={channel} />
            </Section>
            <Section id={'pricing'}>
              <Pricing channel={channel} />
            </Section>
            <Section id={'download'}>
              <Download channel={channel} />
            </Section>
            <SocialMedia />
            <Footer />
          </main>
        </div>
      </TimerProvider>
    </>
  );
};

export default Home;
